





























import { Component, Vue, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { SystemApi, ValueListItem, WorkordersApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: { EditOnClickField },
  computed: mapGetters({
    ordersApi: 'ordersApi',
    systemApi: 'systemApi'
  })
})
export default class RequestTypeEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: 'Request Type' })
  private label!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: true, default: '' })
  private value!: string | number;

  private RequestTypeMode = 'read';
  private RequestTypes!: ValueListItem[];

  private loading!: boolean;

  private systemApi!: SystemApi;
  private ordersApi!: WorkordersApi;

  data() {
    return {
      RequestTypes: undefined,
      loading: false
    };
  }

  private async mounted() {
    this.RequestTypes = await this.systemApi.getValueListItems({
      propertyId: this.propertyId,
      name: 'Request Types'
    });
  }

  private async handleRequestTypeChange(RequestType: string) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === RequestType) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeRequestType({
        workorderId: this.workorderId,
        changeOrderRequestTypeCommand: {
          newRequestType: RequestType
        }
      });
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.RequestTypeMode = 'read';
    this.loading = false;
  }
}
